import React from 'react';
import type { Showcase, ShowcaseProperty, ShowcaseResource } from '../../types';
import { Eye } from 'lucide-react';

interface TourSectionProps {
  showcase: Showcase;
  property: ShowcaseProperty;
  resources: ShowcaseResource[];
  brandColour: string;
  darkMode?: boolean;
}

export default function TourSection({ showcase, property, resources, brandColour, darkMode: dm }: TourSectionProps) {
  const tour = resources[0];
  if (!tour) return null;

  const embedUrl = tour.embed_url || tour.source_url;

  return (
    <section className={`py-16 ${dm ? 'bg-slate-900' : 'bg-white'}`}>
      <div className="max-w-5xl mx-auto px-8">
        <h2 className={`text-2xl font-bold mb-8 ${dm ? 'text-white' : 'text-slate-900'}`}>360° Virtual Tour</h2>
        <div className={`aspect-video rounded-xl overflow-hidden shadow-lg ${dm ? 'bg-slate-800' : 'bg-slate-100'}`}>
          {embedUrl ? (
            <iframe
              src={embedUrl}
              className="w-full h-full"
              allow="fullscreen; gyroscope; accelerometer"
              allowFullScreen
              title="360° virtual tour"
            />
          ) : (
            <div className={`w-full h-full flex flex-col items-center justify-center ${dm ? 'bg-slate-800 text-slate-400' : 'bg-slate-100 text-slate-500'}`}>
              <Eye className="w-16 h-16 mb-3" />
              <p>360° tour available</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
